export default __webpack_public_path__ + "static/media/prefooterBanner.753cb3c4.webp";